import { ReactNode } from "react";
import { IconInfoCircle } from "@tabler/icons-react";

interface LabelProps {
  label?: string;
  strong?: boolean;
  disabled?: boolean;
  icon?: ReactNode;
}

const Label = ({
  label, strong = false, disabled = false, icon,
}: LabelProps) => (
  <div className={`flex w-fit typography-medium-base space-x-1 items-center ${disabled ? "text-icon-disabled" : "text-icon-bg-base"}`}>
    {icon && icon}
    {label && (
      <span className={`${strong ? "typography-medium-strong" : "typography-medium-base"} ${disabled ? "text-text-disabled" : "text-text-base"}`}>
        {label}
      </span>
    )}
    <IconInfoCircle />
  </div>
);

export default Label;
